import { useEffect } from 'react';

interface UseOtpExpiryTimerOptions {
  expiresAt: number | null;
  onExpired: () => void;
  now?: () => number;
}

export function useOtpExpiryTimer({
  expiresAt,
  onExpired,
  now = Date.now,
}: UseOtpExpiryTimerOptions): void {
  useEffect(() => {
    if (expiresAt === null) return;
    const remaining = expiresAt - now();
    if (remaining <= 0) {
      onExpired();
      return;
    }
    const timer = setTimeout(onExpired, remaining);
    return () => clearTimeout(timer);
  }, [expiresAt, onExpired, now]);
}
